// extracted by mini-css-extract-plugin
export default {"scoreContainer":"RatingScoreComponent_scoreContainer__5fY06","header":"RatingScoreComponent_header__SnrtY","options":"RatingScoreComponent_options__o0ttJ"};